// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/components'
import global from '@/utils/global'
import { userKey } from '@/config'

Vue.config.productionTip = false

const USER_KEY = userKey;
const user = {
  userInfo: (() => {
    try {
      const saved = localStorage.getItem(USER_KEY)
      return saved ? JSON.parse(saved) : {}
    } catch (e) {
      console.warn('Failed to parse user info from localStorage', e)
      return {}
    }
  })(),

  set(data) {
    this.userInfo = data
    try {
      localStorage.setItem(USER_KEY, JSON.stringify(data))
    } catch (e) {
      console.error('Failed to save user info to localStorage', e)
    }
  },

  get() {
    return this.userInfo
  },
}
Vue.prototype.$user = user

Vue.prototype.env = process.env.NODE_ENV

Vue.use(ElementUI);
Vue.use(global)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js